import { render, staticRenderFns } from "./GlobalSearchExternalResult.vue?vue&type=template&id=1ed2f86f&"
import script from "./GlobalSearchExternalResult.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchExternalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports